type MeLike = {
  is_owner?: boolean;
  role?: { name?: string | null } | null;
  can_manage_knowledge?: boolean;
} | null;

/**
 * Whether the current member may manage the knowledge base. Structural on
 * `members/me/` (`TMember`): reads `can_manage_knowledge`, which the Django
 * backend derives from the SAME permission it enforces on every knowledge
 * endpoint. This used to match role NAMES against a hardcoded set, mirroring
 * a legacy FastAPI gateway — that duplicated the rule instead of reading it,
 * and the two disagreed (a "manager"-named role could see controls the API
 * then rejected). There is deliberately no name-based fallback: this is
 * purely the UI affordance (nav entry + manage controls), and the server
 * flag is the only source of truth for it.
 */
export function canManageKnowledge(me: MeLike | undefined): boolean {
  return me?.can_manage_knowledge ?? false;
}
